import Head from 'next/head';
import React from 'react';
import Script from 'next/script';
import { withUserTokenSSR, AuthAction, withUser } from 'next-firebase-auth';
import * as Sentry from '@sentry/nextjs';
import PricingPageComponent from '@components/web/pricing/Pricing.Page';

export type PricingPageSubscriptionInterval = 'monthly' | 'annually';

function Pro() {
  return (
    <>
      <Script
        id="cookieyes"
        type="text/javascript"
        src="https://cdn-cookieyes.com/client_data/3ac4d695a7fb984394170f54/script.js"
        strategy="beforeInteractive"
      />
      <Head>
        <title>Explore pricing options for Mimo and choose your plan</title>
        <meta
          name="title"
          content="Mimo Pro: Level up your coding skills with unlimited access, certificates, practice projects, and more!"
          key="title"
        ></meta>
        <meta
          name="description"
          content="Learn to code with Mimo. Our programming courses and career paths are free to start! Learn more about our Free, Pro, and Max plans here."
          key="description"
        ></meta>
        <meta
          name="og:title"
          content="Mimo Pro: Level up your coding skills with unlimited access, certificates, practice projects, and more!"
          key="og:title"
        ></meta>
        <meta
          name="og:description"
          content="Learn to code with Mimo. Our programming courses and career paths are free to start! Learn more about our Free, Pro, and Max plans here."
          key="og:description"
        ></meta>
        <meta
          name="twitter:title"
          content="Mimo Pro: Level up your coding skills with unlimited access, certificates, practice projects, and more!"
          key="twitter:title"
        ></meta>
        <meta
          name="twitter:description"
          content="Start your 7-day free trial of Mimo Pro. With exclusive benefits and features to supercharge their learning, Mimo Pro members are 4 times more likely to reach their goals!"
          key="twitter:description"
        ></meta>
      </Head>
      <PricingPageComponent></PricingPageComponent>
    </>
  );
}

export const getServerSideProps = withUserTokenSSR({
  whenUnauthed: AuthAction.RENDER,
})(async (ctx) => {
  const user = ctx.user;

  const isAuthenticated = !!user?.id;

  Sentry.setUser({
    id: user?.id || '',
    name: user?.displayName,
    email: user?.email || '',
  });

  Sentry.setTag(
    'environment',
    ctx.req.headers.host?.split(':')[0] === 'localhost'
      ? 'development'
      : 'production',
  );

  if (isAuthenticated) {
    return {
      redirect: {
        destination: '/web/subscribe',
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
});

export default withUser({})(Pro);
